export const PASSWORD_MIN_LENGTH = 6;
export const PASSWORD_MAX_LENGTH = 20;

export const passwordValidator = (password) =>
    password && password.length >= PASSWORD_MIN_LENGTH && password.length <= PASSWORD_MAX_LENGTH;

export const passwordConfirmationValidator = (password, confirmationPassword) =>
   confirmationPassword && confirmationPassword === password;

export const validatePasswordFields = (
    newPassword,
    confirmationPassword,
    currentPassword = undefined,
    requireCurrent = false
) => {
    const errors = [];

    if (requireCurrent && (!currentPassword || !currentPassword.trim())) {
        errors.push('Current password is required.');
    }

    if (!newPassword || !newPassword.trim()) {
        errors.push('New password is required.');
    }

    if (!confirmationPassword || !confirmationPassword.trim()) {
        errors.push('Password confirmation is required.');
    }

    if (newPassword && !passwordValidator(newPassword)) {
        errors.push(`New password must be between ${PASSWORD_MIN_LENGTH} and ${PASSWORD_MAX_LENGTH} characters.`);
    }

    if (newPassword && confirmationPassword && !passwordConfirmationValidator(newPassword, confirmationPassword)) {
        errors.push('New password and confirmation must match.');
    }

    return {
        isValid: errors.length === 0,
        errors
    };
};

export const getPasswordValidationState = (password, validator) => {
    if (!password || password.length === 0) {
        return null;
    }
    return validator(password) ? 'success' : 'error';
};



/** WEBPACK FOOTER **
 ** ./src/utils/passwordValidation.js
 **/